'use client'
import React, { useContext, useEffect, useState } from 'react';
import { ProductContext } from '../../lib/productContext';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import { Button, Flex, Text, Link, Tooltip, IconButton, useToast } from '@chakra-ui/react';
import { MdContentCopy } from 'react-icons/md';
import ProductAsideUsefulLinksForm from './productAsideUsefulLinksForm';
import { ProductPageContext } from '../lib/productPageContext';
export default function ProductAsideUsefulLinks() {
  const {
    product,
    rights,
  } = useContext(ProductContext);
  const [seeMore, setSeeMore] = useState(false);
  const [displaySeeMore, setDisplaySeeMore] = useState(true);
  const toast = useToast();
  const {
    editingUsefulLinks,
    setEditingUsefulLinks
  } = useContext(ProductPageContext);
  const copyToClipboard = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast({
        title: "Link copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      console.error('Erreur lors de la copie:', err);
    }
  };
  return (
    <> { (product && 
      ( (product.useful_links && product.useful_links.length > 0) || editingUsefulLinks))&& (
      <Flex px={3} py={2} flexDirection={"column"}>
        <InlineFormWrapper
          width={"100%"}
          canEdit={rights.can_update}
          toggle={editingUsefulLinks}
          onToggle={(toggle) => {
            setEditingUsefulLinks(toggle);
            setDisplaySeeMore(!toggle);
          }}
          value={
            <Flex flexDirection={"column"}>
              <Text
                color="text.medium.grey"
              >Useful Links</Text>
              <Flex flexDirection={"column"}>
                {(product.useful_links && product.useful_links.length > 0) && product.useful_links.map((link, i) => (
                  <Flex key={i}>
                    {((i < 3) || (i >= 3 && seeMore)) &&
                      <Flex mt={1}>
                        <Tooltip 
                          label={link.url}
                          placement="top"
                          hasArrow
                        >
                          <Text 
                            fontWeight="medium" 
                            textDecoration="underline"
                            cursor="pointer"
                            color="text.medium.blue"
                            _hover={{ color: "fill.blue" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(link.url, '_blank');
                            }}
                          >
                            {link.title}
                          </Text>
                        </Tooltip>
                      </Flex>
                    }
                  </Flex>
                ))}
              </Flex>
            </Flex>
          }
        >
          {(close) => (
            <ProductAsideUsefulLinksForm
              key={`useful-links-form-${editingUsefulLinks}`}
              onSubmitted={() => {
                close();
                setEditingUsefulLinks(false);
              }}
              onCancel={() => {
                close();
                setEditingUsefulLinks(false);
              }}
            />
          )}
        </InlineFormWrapper>
        {displaySeeMore &&
          <>
            {(product.useful_links && product.useful_links.length > 3 && !seeMore) &&
              <Button variant="purpleTransparent" px={0} onClick={() => { setSeeMore(true) }}>See more</Button>
            }
            {(product.useful_links && product.useful_links.length > 3 && seeMore) &&
              <Button variant="purpleTransparent" px={0} onClick={() => { setSeeMore(false) }}>See less</Button>
            }
          </>
        }
      </Flex>
    )}
    </>
  )
} 